"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagHaulerColumnFullWidthProps = exports.rfidTagHaulerColumnProps = void 0;
exports.rfidTagHaulerColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler No',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'rfid_tag',
        title: 'Tag Id',
        width: '500px',
        filter: 'text',
    },
];
exports.rfidTagHaulerColumnFullWidthProps = [
    ...exports.rfidTagHaulerColumnProps
];
exports.rfidTagHaulerColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor_name',
    title: 'Contractor',
    width: 'auto',
    filter: 'text'
};
